import React, { useEffect, useState } from "react";
import { Grid, Box } from "@mui/material";

import CustomModal from "../../CustomModal/CustomModal";
import ModalFooter from "../../CustomModal/ModalFooter";
import ModalHeader from "../../CustomModal/ModalHeader";
import CustomTextField from "../../../components/CustomTextField/CustomTextField";
import * as _ from "lodash";
import CustomDatePicker from "../../../components/CustomDatePicker/CustomDatePicker";
import CustomAutoComplete from "../../../components/CustomAutoComplete/CustomAutoComplete";
import moment from "moment";

import { fonts, themes } from "../../../themes/themes";
import DropAndSelect from "../../../components/DropAndSelect/DropAndSelect";
import { toast } from "react-hot-toast";
import Compdirection from "../../../themes/CompDirection";
interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  allInsurerTypes: any;
  allPolicyTypes: any;
  callBackGetData: (data: any) => void;
  trans?: any;
}

const AddInsurancePresenter = ({
  isModalOpen,
  closeModal,
  callBackGetData,
  allInsurerTypes,
  allPolicyTypes,
  trans,
}: ModalProps) => {
  const [amount, setAmount] = useState();
  const [policyNumber, setPolicyNumber] = useState();

  const [category, setCategory] = useState();

  const [policyTypeName, setPolicyTypeName] = useState("");
  const [policyTypeId, setPolicyTypeId] = useState("");

  const [insurerTypeName, setInsurerTypeName] = useState("");
  const [insurerTypeId, setInsurerTypeId] = useState("");

  const [startDate, setStartDate] = useState<any>(new Date());
  const [endDate, setEndDate] = useState<any>(new Date());

  const [proofAttachment, setProofAttachment] = useState(null);
  const [proofAttachmentPath, setProofAttachmentPath] = useState("");
  const [proofAttachmentName, setProofAttachmentName] = useState("");
  const [isPDF, setIsPDF] = useState<boolean>(false);
  const [pdfName, setPDFName] = useState("");
  const [newattachement, setNewAttachement] = useState(false);
  const insuranceDocumentsUpload = (e: any) => {
    const file: any = e.target.files[0];
    setNewAttachement(true);
    if (file?.type.includes("image")) {
      const image_as_base64 = URL.createObjectURL(e.target.files[0]);
      const image_as_files: any = file;

      setProofAttachment(image_as_files);
      setProofAttachmentPath(image_as_base64);
    } else {
      setIsPDF(true);
      setPDFName(file?.name);
      setProofAttachment(file);
    }
  };
  const handleInsurerType = (insurerName: any) => {
    const getInsurer = _.filter(allInsurerTypes, function (insurer: any) {
      return insurer.name === insurerName;
    });
    if (getInsurer.length) {
      const insurer_type = getInsurer[0];
      setInsurerTypeId(insurer_type.id);
      setInsurerTypeName(insurerName);
    }
  };

  const handlePolicyType = (policyName: any) => {
    const getPolicy = _.filter(allPolicyTypes, function (policy: any) {
      return policy.name === policyName;
    });
    if (getPolicy.length) {
      const policy_type = getPolicy[0];
      setPolicyTypeId(policy_type.id);
      setPolicyTypeName(policyName);
    }
  };
  const handleSubmit = () => {
    const start_date = moment(startDate.$d).format("YYYY-MM-DD");
    const end_date = moment(endDate.$d).format("YYYY-MM-DD");

    callBackGetData({
      insurer: insurerTypeId,
      policy_type: policyTypeId,
      policy_number: policyNumber,
      start_date: start_date,
      end_date: end_date,
      category: category,
      amount: amount,
      attachments: proofAttachment,
      newattachement: newattachement,
    });
    closeModal();
  };

  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="687px"
      modalWidth="550px"
    >
      <ModalHeader
        modal={{ modal_title: trans("Add Insurance") }}
        closeModal={closeModal}
      />
      <Compdirection>
        <Grid
          container
          spacing={3}
          style={{
            marginTop: "5px",
          }}
        >
          <Grid item xs={6}>
            <CustomAutoComplete
              label={trans("Insurance Company")}
              options={_.map(allInsurerTypes, (insurer: any) => {
                return insurer.name;
              })}
              value={insurerTypeName}
              onChange={(event: any, newValue: any) => {
                handleInsurerType(newValue);
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <CustomAutoComplete
              label={trans("Policy Type")}
              options={_.map(allPolicyTypes, (policy: any) => {
                return policy.name;
              })}
              value={policyTypeName}
              onChange={(event: any, newValue: any) => {
                handlePolicyType(newValue);
              }}
            />
          </Grid>

          <Grid item xs={6}>
            <CustomTextField
              type="string"
              label={trans("Policy Number")}
              placeholder={trans("Write Policy Number")}
              value={policyNumber}
              onChange={(e: any) => setPolicyNumber(e.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            <CustomTextField
              type="string"
              label={trans("Category")}
              placeholder={trans("Write Category")}
              value={category}
              onChange={(e: any) => setCategory(e.target.value)}
            />
          </Grid>

          <Grid item xs={6}>
            <CustomDatePicker
              label={trans("Start Date")}
              value={new Date(startDate)}
              onChange={(newValue: any) => {
                if (newValue > endDate) {
                  toast.error(
                    trans("Start date must be less than from end date")
                  );
                } else {
                  setStartDate(newValue);
                }
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <CustomDatePicker
              label={trans("End Date")}
              value={new Date(endDate)}
              onChange={(newValue: any) => {
                if (newValue < startDate) {
                  toast.error(
                    trans("End date must be greater than from end date")
                  );
                } else {
                  setEndDate(newValue);
                }
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <CustomTextField
              type="number"
              label={trans("Amount")}
              placeholder={trans("Write Amount")}
              value={amount}
              onChange={(e: any) => setAmount(e.target.value)}
            />
          </Grid>

          <Grid item xs={5}>
            <DropAndSelect
              upload={insuranceDocumentsUpload}
              src={proofAttachmentPath}
              isPDF={isPDF}
              pdfName={pdfName}
              onDelete={() => {
                setPDFName("");
                setIsPDF(false);
                setProofAttachmentPath("");
                setNewAttachement(false);
              }}
            />
          </Grid>
        </Grid>
      </Compdirection>

      <Box style={{ marginTop: "35px" }} />
      <ModalFooter
        onClickSubmit={() => handleSubmit()}
        onClickCancel={() => {
          closeModal();
        }}
      />
    </CustomModal>
  );
};

export default AddInsurancePresenter;
